export const PRINT_STYLES = {
  h2: { fontFamily: "Georgia,'Times New Roman',serif", fontSize: 18, margin: "26px 0 10px", color: "#D6637B" },
  td: { padding: "7px 0", borderBottom: "1px solid #f3e8ee", fontFamily: "Georgia,serif", color: "#2D2424" },
  list: { fontFamily: "Georgia,serif", color: "#2D2424", paddingLeft: 20, lineHeight: 1.6 },
  small: { fontFamily: "Georgia,serif", fontSize: 13, color: "#6E5E5E", lineHeight: 1.6 },
};

const PrintSheet = ({ id, eyebrow, title, subtitle, children }) => (
  <div className="print-only" data-testid={id} aria-hidden="true">
    <img src="/images/logo.png" alt="Le Allegre Pasticcione" style={{ height: 72, marginBottom: 10 }} />
    {eyebrow ? (
      <p style={{ fontSize: 12, letterSpacing: 2, color: "#D6637B", fontWeight: 700, margin: 0, fontFamily: "Georgia,serif" }}>
        {eyebrow}
      </p>
    ) : null}
    <h1 style={{ fontFamily: "Georgia,'Times New Roman',serif", fontSize: 26, margin: "2px 0 6px", color: "#2D2424" }}>
      {title}
    </h1>
    {subtitle ? (
      <p style={{ fontFamily: "Georgia,serif", color: "#2D2424", lineHeight: 1.6, margin: "0 0 4px" }}>{subtitle}</p>
    ) : null}
    {children}
    <p
      style={{
        marginTop: 34,
        fontSize: 12,
        color: "#9E8E8E",
        borderTop: "1px solid #f3e8ee",
        paddingTop: 12,
        fontFamily: "Georgia,serif",
      }}
    >
      Le Allegre Pasticcione · instagram.com/giorgiaperletta · youtube.com/@leallegrepasticcione
    </p>
  </div>
);

export default PrintSheet;
